import { loanRoleRelationshipsApi } from 'app/services/api';
import { normalize, schema } from 'normalizr';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE = createNamedActions('loanRoles', {
  GET_LOAN_ROLE_RELATIONSHIPS: 'GET_LOAN_ROLE_RELATIONSHIPS',
  CREATE_LOAN_ROLE_RELATIONSHIPS: 'CREATE_LOAN_ROLE_RELATIONSHIPS',
  EDIT_LOAN_ROLE_RELATIONSHIPS: 'EDIT_LOAN_ROLE_RELATIONSHIPS',
  DELETE_LOAN_ROLE_RELATIONSHIPS: 'DELETE_LOAN_ROLE_RELATIONSHIPS',
});

const loanRoleRelationshipsSchema = new schema.Entity('data', {}, { idAttribute: 'id' });

export const getLoanRoleRelationshipsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanRoleRelationshipsApi.getLoanRoleRelationships(params);

  return dispatch({
    type: LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.GET_LOAN_ROLE_RELATIONSHIPS,
    payload: normalize(data, [loanRoleRelationshipsSchema]).entities.data,
  });
});

export const createLoanRoleRelationshipsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanRoleRelationshipsApi.createLoanRoleRelationship(params);

  return dispatch({
    type: LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.CREATE_LOAN_ROLE_RELATIONSHIPS,
    payload: data,
  });
});

export const editLoanRoleRelationshipsAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await loanRoleRelationshipsApi.editLoanRoleRelationship(params);

  return dispatch({
    type: LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.EDIT_LOAN_ROLE_RELATIONSHIPS,
    payload: data,
  });
});

export const deleteLoanRoleRelationshipsAction = params => async dispatch => {
  const { data } = await loanRoleRelationshipsApi.deleteLoanRoleRelationship(params);

  return dispatch({
    type: LOAN_ROLE_RELATIONSHIPS_ACTION_TYPE.DELETE_LOAN_ROLE_RELATIONSHIPS,
    payload: data,
    meta: params,
  });
};
